import { useRef, useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CreateProjectBookMark } from 'shared-types'
import { UseProjectProps, useSession } from '~/hooks'
import { Client } from '../../customClients/client'

export const useProject = ({
  projectTitle,
  projectId,
  isBookmarked: initialIsBookmarked = false,
}: UseProjectProps) => {
  const [isBookmarked, setIsBookmarked] = useState(initialIsBookmarked)
  const isUpdatingBookmarkRef = useRef(false)
  const queryClient = useQueryClient()
  const { session } = useSession()

  const { mutateAsync: updateProjectBookmark } = useMutation(
    async (payload: Omit<CreateProjectBookMark, 'productIds'>) => {
      return Client.projectList.updateProjectBookmark(payload, session)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['bookmark-project'] })
      },
    }
  )

  const toggleBookmarkProject = () => {
    setIsBookmarked(!isBookmarked)
  }

  const handleOnBookMarkProject = async () => {
    if (isUpdatingBookmarkRef.current) {
      return
    }

    isUpdatingBookmarkRef.current = true

    try {
      toggleBookmarkProject()
      await updateProjectBookmark({
        name: projectTitle,
        projectId,
        status: !isBookmarked,
      })
    } catch (error) {
      toggleBookmarkProject()
      throw error
    }

    isUpdatingBookmarkRef.current = false
  }

  return {
    isBookmarked,
    handleOnBookMarkProject,
  }
}
